export default {
  BIND_MOBILE: 1,
  BIND_EMAIL: 2,
  REBIND_MOBILE: 3,
  REBIND_EMAIL: 4,
  UNBIND_MOBILE: 5,
  UNBIND_EMAIL: 6,
  UNBIND_THIRD_PARTY: 7,
  UPDATE_PASSWORD: 8,
  FIND_PASSWORD: 9,
  WITHDRAW: 10,
  BIND_GA: 11,
  REBIND_GA: 12,
  UNBIND_GA: 13,
  NEW_UNBIND_GA: 20,
  WHITESTATUSUPDATE: 25,
  WHITELISTUPDATE: 26,
  // 快捷提币场景类型
  QUICK_WITHDRAW: 28,
  // 设置快捷提币额度场景类型
  WITHDRAW_LIMIT: 29
} as any;
